module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yd-news-duotu",
    on: {
      "click": function($event) {
        _vm.newsClick(_vm.newsData.newsContentURL)
      }
    }
  }, [(_vm.newsData.newsContentTitle) ? _c('p', {
    staticClass: "yd-title"
  }, [_vm._v(_vm._s(_vm.newsData.newsContentTitle))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "yd-img-container"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.threeImages[0]),
      expression: "threeImages[0]"
    }],
    attrs: {
      "src": _vm.threeImages[0],
      "alt": "请输入正确的图片地址"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.threeImages[1]),
      expression: "threeImages[1]"
    }],
    attrs: {
      "src": _vm.threeImages[1],
      "alt": "请输入正确的图片地址"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.threeImages[2]),
      expression: "threeImages[2]"
    }],
    attrs: {
      "src": _vm.threeImages[2],
      "alt": "请输入正确的图片地址"
    }
  })]), _vm._v(" "), (_vm.newsData.newsContentSource) ? _c('div', {
    staticClass: "yd-module-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.newsData.newsContentSource))]), _vm._v(" "), (_vm.newsData.newsContentUpdateTime) ? _c('span', [_vm._v(_vm._s(_vm.newsData.newsContentUpdateTime))]) : _c('span', [_vm._v(_vm._s(_vm.getCurrentTime()))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-26995916"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/market/common/newsTemplate/ThreeImg.vue
// module id = 746
// module chunks = 1